import { IAppState } from '../../redux';
import { EUnavailableReason } from '../../redux/reducers';

export const selectIsDeniedBySanctions = (state: IAppState): boolean =>
  Object.values(state.publishTerms.services).some(
    ({ unavailableReasonType: r }) => r === EUnavailableReason.deniedBySanctions,
  );
